import {NoPreloading, type Routes, provideRouter, withPreloading, withViewTransitions} from '@angular/router'
import {routes} from '@cart/src/app/app.routes'

const brandingRoutes: Routes = [
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage),
  },
]

const allRoutes: Routes = [...brandingRoutes, ...routes]

export function provideAppRouter() {
  return provideRouter(allRoutes, withPreloading(NoPreloading), withViewTransitions())
}
